module.exports = __webpack_public_path__ + "static/media/flickr-icon.1824ca87.svg";